import React, { Fragment } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import Cookies from 'universal-cookie';
import { ClearCookies } from '../Utilities/Utilities';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux'
import { LogoutUser } from '../Redux/UsersDucks';

// Add this to your existing exports
//export { getConsultantIdentifier };


const Header = () => {
    const cookies = new Cookies();
    const navigate = useNavigate();
    const dispatch = useDispatch()

    
    const username = cookies.get('userName');



 
    /*if (username == undefined || username == null ) { 
        dispatch(LogoutUser())
        navigate("/")
    }*/

    const onClickButtonDelete = () => {
        dispatch(LogoutUser())
        navigate("/")
    }

    return (
        <Fragment>
            <header className="header">
                <div className="navbar navbar-expand-lg px-4 py-2 bg-white shadow" style={{height:'65px'}}>
                <NavLink className="sidebar-toggle text-gray-500 me-4 me-lg-5 lead d-block d-sm-none"  >
                        <Icon.List style={{color: "black" , fontSize:'20px'}}/>
                    </NavLink>
                    
                    <NavLink className="navbar-brand fw-bold text-uppercase text-base" to="/Home">
                        <span className="d-none d-brand-partial"><img src='/logo3.png' width="70px"/> </span>
                    </NavLink>
                    <div className="ms-auto d-flex align-items-center list-unstyled mb-0">
                        <div className="nav-item dropdown ms-auto">
                            <span className="d-none d-sm-inline">Bienvenido {username}</span>
          
                        </div>
                  
                      
              {/*           <div className="nav-item dropdown ms-auto">
                            <NavLink className="nav-link pe-0" to="/Inicio">
                                <img className="avatar p-1" src={avatar1}/>
                            </NavLink>
                        </div> */}
                        <div className="nav-item dropdown ms-auto">
                            <NavLink className="nav-link pe-0" to={"/"}>
                                <Button variant="primary" size="sm" type='button' onClick={onClickButtonDelete}>Cerrar Sesión</Button>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </header>
        </Fragment >
    );
}

export default Header;
